import { useRef, useState, useEffect } from "react";
import { FaBars, FaTimes, FaChevronLeft, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
import { FaFileAlt, FaHistory, FaUsers, FaUser, FaComments, FaTelegram } from "react-icons/fa";
import { FaExchangeAlt } from "react-icons/fa";
import { FaTruck } from "react-icons/fa";
import axios from 'axios';
import "../header/Header.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/Auth";
import { SiConvertio } from "react-icons/si";

function Header() {
    const navRef = useRef();
    const { user, logout } = useAuth();
    const userRole = user?.role;
    const isLoggedIn = localStorage.getItem('refreshToken');
    const [isExpanded, setIsExpanded] = useState(false);
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [telegramLink, setTelegramLink] = useState("");
    const [translations, setTranslations] = useState({
        conv: '',
        suppliers: '',
        about: '',
        history: '',
        profile: '',
        exit: ''
    });
    const [userLanguage, setUserLanguage] = useState('uk-UA');
    const [contractorRegion, setContractorRegion] = useState('uk-UA');
    const [loading, setLoading] = useState(true);
    const [generalError, setGeneralError] = useState("");
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState('UK');

    useEffect(() => {
        const fetchData = async () => {
            if (user?.user_id) {
                try {
                    const userId = user.user_id;
                    const [
                        usernameResponse, 
                        telegramResponse,
                        regionResponse,
                        contractorRegionResponse
                    ] = await Promise.all([
                        axios.get(`https://bank2.daolog.net/current-user/${userId}`),
                        axios.get(`https://bank2.daolog.net/user-telegram-link/${userId}`),
                        axios.get(`https://bank2.daolog.net/user-region/${userId}`),
                        axios.get(`https://bank2.daolog.net/contractor-region-by-user/${userId}`)
                    ]);
    
                    setUsername(`<b></b> <b>${usernameResponse.data.username}</b>`);
                    setTelegramLink(telegramResponse.data.group_name);
                    
                    // Отримуємо регіон користувача з таблиці users
                    const userRegion = regionResponse.data.region;
                    setUserLanguage(userRegion);
                    
                    // Встановлюємо поточну мову на основі регіону користувача
                    if (userRegion === 'pl-PL') {
                        setCurrentLanguage('PL');
                    } else if (userRegion === 'cs-CZ') {
                        setCurrentLanguage('CZ');
                    } else {
                        setCurrentLanguage('UK');
                    }
                    
                    // Отримуємо регіон з конфігу контрагента для посилань
                    const contractorRegionData = contractorRegionResponse.data.region;
                    setContractorRegion(contractorRegionData);

                    // Використовуємо переклади з регіону користувача (з таблиці users)
                    const translationsResponse = await axios.get(`https://bank2.daolog.net/translations/header/${userRegion}`);
                    setTranslations(translationsResponse.data);
    
                } catch (err) {
                    console.error('Error fetching data:', err);
                    if (err.response && err.response.status === 401) {
                        logout();
                        navigate('/Login');
                    }
                    setGeneralError(userLanguage === 'pl-PL' ? 'Użytkownik nie jest autoryzowany' : 
                                   userLanguage === 'cs-CZ' ? 'Uživatel není autorizován' : 
                                   'Користувач не авторизований');
                }
            }
            setLoading(false);
        };
        fetchData();
    }, [user, navigate, logout, userLanguage]);

    const showSidebar = () => {
        navRef.current.classList.toggle("responsive_nav");
    };

    const handleMouseEnter = () => {
        setIsExpanded(true);
    };

    const handleMouseLeave = (e) => {
        const header = e.currentTarget;
        const relatedTarget = e.relatedTarget;
        
        if (relatedTarget instanceof Node && !header.contains(relatedTarget)) {
            setIsExpanded(false);
        }
    };

    const toggleSidebar = () => {
        setIsExpanded(!isExpanded);
    };

    const handleLogout = () => {
        logout();
        setUsername(""); 
        navigate('/Login');
    };

    const handleLanguageChange = async (language) => {
        try {
            const userId = user.user_id;
            let region;
            
            // Визначаємо регіон на основі вибраної мови
            if (language === 'UK') {
                region = 'uk-UA';
            } else if (language === 'PL') {
                region = 'pl-PL';
            } else if (language === 'CZ') {
                region = 'cs-CZ';
            } else {
                region = 'uk-UA'; // За замовчуванням
            }
            
            // Оновлюємо регіон користувача в базі даних
            await axios.put(`https://bank2.daolog.net/update-user-region/${userId}`, {
                region: region
            });
            
            setCurrentLanguage(language);
            setUserLanguage(region);
            
            // Оновлюємо переклади з нового регіону користувача
            const translationsResponse = await axios.get(`https://bank2.daolog.net/translations/header/${region}`);
            setTranslations(translationsResponse.data);
            
            setShowLanguageDropdown(false);
            
            // Перезавантажуємо сторінку для застосування змін
            window.location.reload();
            
        } catch (error) {
            console.error('Error updating user region:', error);
            alert('Помилка при оновленні мови');
        }
    };

    const toggleLanguageDropdown = () => {
        setShowLanguageDropdown(!showLanguageDropdown);
    };

    if (loading) {
        return <div>Loading...</div>;
    }
  
    if (generalError) {
        return <div>{generalError}</div>;
    }

   const getSuppliersPageUrl = () => {
    // Якщо contractorRegion ще не завантажився, повертаємо заглушку
    if (!contractorRegion) {
        return '/SuppliersPage'; // або '/loading' чи інший маршрут за замовчуванням
    }
    
    if (contractorRegion === 'pl-PL') {
        return '/SuppliersPagePl';
    } else if (contractorRegion === 'cs-CZ') {
        return '/SuppliersPageCz';
    } else {
        return '/SuppliersPage';
    }
};

const getDescriptionPagePageUrl = () => {
    // Якщо contractorRegion ще не завантажився, повертаємо заглушку
    if (!contractorRegion) {
        return '/DescriptionPage'; // або '/loading' чи інший маршрут за замовчуванням
    }
    
    if (contractorRegion === 'pl-PL') {
        return '/DescriptionPagePL';
    } else if (contractorRegion === 'cs-CZ') {
        return '/SuppliersPageCz';
    } else {
        return '/DescriptionPage';
    }
};

    return (
        <>
            <header 
                className={isExpanded ? "expanded" : "collapsed"}
                onMouseLeave={handleMouseLeave}
            >
                <h2>{isExpanded ? "Bank statement" : ""}</h2>
                <nav ref={navRef}>
                    {isLoggedIn ? (
                        <>
                            <div className="nav-links">
                                <a href="/Fixfile" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.conv || '') : <SiConvertio style={{marginTop:"50px"}} size={26} />}
                                </a>
                        
                                <a href="/ContractorSelector" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.change || '') : <FaExchangeAlt size={26} />}
                                </a>

                                <a href={getDescriptionPagePageUrl()} onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.suppliersdecription || '') : <FaTruck size={26} />}
                                </a>
                                <a href={getSuppliersPageUrl()} onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.suppliers || '') : <FaTruck size={26} />}
                                </a>
                                <a href="/Fop" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.about || '') : <FaUsers size={26} />}
                                </a>
                                <a href="/Historyd" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.history || '') : <FaHistory size={26} />}
                                </a>
                                <a href="/UserProfile" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.profile || '') : <FaUser size={26} />}
                                </a>
                                <a href="#" onClick={handleLogout} onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? (translations?.exit || '') : <FaSignOutAlt size={26} />}
                                </a>
                            </div>
                        </>
                    ) : (
                        <a href="/Login">
                            Login
                        </a>
                    )}
                    <button className="nav-btn nav-close-btn" onClick={showSidebar}>
                        <FaTimes />
                    </button>
                </nav>
                <button className="nav-btn" onClick={showSidebar}>
                    <FaBars />
                </button>
                <button className="toggle-btn" onClick={toggleSidebar}>
                    {isExpanded ? <FaChevronLeft /> : <FaChevronRight />}
                </button>
            </header>
            <div className="top-bar">
                <div className="top-bar-content">
                    <div className="username" dangerouslySetInnerHTML={{__html: username}}></div>
                    <div className="phone-number">tel. 0 67 333 98 80 (07:00 - 01:00)  </div>
                    <div className="top-bar-buttons">
                        <div className="language-selector">
                            <button className="top-bar-btn language-btn" onClick={toggleLanguageDropdown}>
                                {currentLanguage}
                            </button>
                            {showLanguageDropdown && (
                                <div className="language-dropdown">
                                    <button 
                                        className={`language-option ${currentLanguage === 'UK' ? 'active' : ''}`}
                                        onClick={() => handleLanguageChange('UK')}
                                    >
                                        UK
                                    </button>
                                    <button 
                                        className={`language-option ${currentLanguage === 'PL' ? 'active' : ''}`}
                                        onClick={() => handleLanguageChange('PL')}
                                    >
                                        PL
                                    </button>
                                    <button 
                                        className={`language-option ${currentLanguage === 'CZ' ? 'active' : ''}`}
                                        onClick={() => handleLanguageChange('CZ')}
                                    >
                                        CZ
                                    </button>
                                </div>
                            )}
                        </div>
                        <a href={telegramLink} target="_blank" rel="noopener noreferrer" className="top-bar-btn telegram-btn">
                            <FaTelegram className="btn-icon" />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;